module.exports = __webpack_public_path__ + "static/media/prize-2.8307fa82.png";